import React from "react";

import { Button } from "../../../components/Field";
import { formatAmount } from "../../../helpers/format";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Spacer from "../../../components/Spacer";

import style from "./style.module.css";

export default function PriceCard({ item = {}, size = "col3", onHover, onClick = () => { } }) {
    return (
        <div className={`${style.priceCard} ${style[size]}`}>
            <div className={style.priceCardInner}>
                <Link to={`/register/${item.id}`} className={style.fullBlock}></Link>
                <div className={style.priceCardRow}>
                    <div className={style.priceCardHeader}>
                        {
                            item.tag !== undefined && item.tag !== null && (
                                <div className={style.tag}>{item.tag}</div>
                            )
                        }
                        {
                            [undefined, null].includes(item.tag) && (
                                <div className={`${style.tag} ${style.tagEmpty}`}>Empty</div>
                            )
                        }
                    </div>
                    <div className={style.priceCardBody}>
                        <div className={`${style.mainArea}`}>
                            <Title
                                tag="h5"
                                className="fontTeko"
                                transform="textUpperCase"
                            >
                                <span className={style.coloredTitle}>{item.colored_title}</span> {item.normal_title}
                            </Title>
                            {
                                item.description !== undefined && item.description !== "" && (
                                    <div className={style.descriptionWrap}>
                                        <Editor text={item.description} />
                                    </div>
                                )
                            }
                            <Spacer size={"32"} />
                            {
                                item.price !== undefined && item.price !== "" && (
                                    <div className={style.priceWrap}>
                                        <Title tag="h3">
                                            {formatAmount(item.price, "£")}
                                            {item.validity_txt && <span className={style.validityText}>{item.validity_txt}</span>}
                                        </Title>
                                        {
                                            item.tax_detail !== undefined && item.tax_detail !== null && (
                                                <span className={style.taxDetail}>{item.tax_detail}</span>
                                            )
                                        }
                                        {
                                            [undefined, null].includes(item.tax_detail) && (
                                                <span className={`${style.taxDetail} ${style.taxDetailEmpty}`}>Empty</span>
                                            )
                                        }
                                    </div>
                                )
                            }
                            <Spacer size={"32"} />
                        </div>
                        <div className={`${style.subArea}`}>
                            <Spacer size={"32"} />
                            <Button
                                size="buttonFullWidth"
                                color="buttonPrimary"
                                link={`/register/${item.id}`}
                                label={item.btn_label}
                            />
                            <Spacer size={"32"} />
                            {
                                item.feature.title !== undefined && item.feature.title !== null && item.feature.title !== "" && (
                                    <div className={style.titleWrap}>
                                        <Title
                                            tag="h6"
                                            className="fontMontserrat"
                                            transform="textUpperCase"
                                        >
                                            {item.feature.title}
                                        </Title>
                                    </div>
                                )
                            }
                            {
                                item.feature.description !== undefined && item.feature.description !== null && item.feature.description !== "" && (
                                    <div className={style.descWrap}>
                                        <Spacer size={"16"} />
                                        <Title
                                            tag="p"
                                        >
                                            {item.feature.description}
                                            {
                                                item.feature.feature_tag !== undefined && item.feature.feature_tag !== null && item.feature.feature_tag !== "" && (
                                                    <span className={style.featureTag}>{item.feature.feature_tag}</span>
                                                )
                                            }
                                        </Title>
                                    </div>
                                )
                            }
                            <div className={style.featureList}>
                                {
                                    item.feature.list.length > 0 && item.feature.list.map((item, index) => {
                                        return (
                                            <div className={style.featureListItem} key={`featureListItem_${item.index}`}>
                                                <label class={style.checkbox}>
                                                    <input type="checkbox" class={style.checkboxInput} />
                                                    <div class={style.checkboxSquare}></div>
                                                    <div class={style.checkboxText}><span>{item.feature_name}</span></div>
                                                </label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}